import { useLang } from "@/context/LanguageContext";
import { Shield, Zap, Wifi, UtensilsCrossed, Volleyball, TreePine, Flame, Users } from "lucide-react";

const ROOM_INTERIOR = "https://customer-assets.emergentagent.com/job_ef4fdd3f-901c-4603-a956-907996740397/artifacts/dj0efzcp_Slide_15.png";
const AMENITIES_IMG = "https://customer-assets.emergentagent.com/job_ef4fdd3f-901c-4603-a956-907996740397/artifacts/ugtl9jle_Slide_03.png";

const ICONS = [Zap, Wifi, UtensilsCrossed, Volleyball, Shield, TreePine, Flame, Users];

export default function Welcome() {
  const { t, lang } = useLang();

  return (
    <section className="bg-cream-100 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <p className="eyebrow tag-line" data-testid="welcome-eyebrow">{t.welcome.eyebrow}</p>
            <h2 className={`mt-6 text-4xl md:text-5xl font-display tracking-tight text-forest-700 leading-[1.08] ${lang==='bn'?'font-bn':''}`}
                data-testid="welcome-title">
              {t.welcome.title}
            </h2>
            <div className="gold-rule mt-8" />
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-base md:text-lg text-slate-warm leading-relaxed" data-testid="welcome-body">
              {t.welcome.body}
            </p>
            <div className="mt-10 grid grid-cols-2 gap-4">
              {[t.welcome.pill_1, t.welcome.pill_2, t.welcome.pill_3, t.welcome.pill_4].map((p) => (
                <div key={p} className="flex items-center gap-3 border-t border-forest-100 pt-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-gold-600" />
                  <span className="text-sm text-forest-700">{p}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Image strip */}
        <div className="mt-20 grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-7 group overflow-hidden rounded-md border border-forest-100">
            <img src={ROOM_INTERIOR} alt="Naljuri Inn premium room interior"
                 className="w-full h-[420px] md:h-[520px] object-cover img-zoom" />
          </div>
          <div className="lg:col-span-5 group overflow-hidden rounded-md border border-forest-100">
            <img src={AMENITIES_IMG} alt="Basketball court and forest amenities at Naljuri Inn"
                 className="w-full h-[420px] md:h-[520px] object-cover img-zoom" />
          </div>
        </div>
      </div>

      {/* Amenities */}
      <div className="border-t border-forest-100 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
          <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
            <div className="lg:col-span-7">
              <p className="eyebrow tag-line">{t.amenities.eyebrow}</p>
              <h2 className={`mt-4 text-3xl md:text-4xl font-display text-forest-700 tracking-tight ${lang==='bn'?'font-bn':''}`}>
                {t.amenities.title}
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {t.amenities.items.map((item, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <div key={item} className="group p-6 border border-forest-100 rounded-md hover:border-gold-600 transition-colors"
                     data-testid={`amenity-${i}`}>
                  <Icon className="w-6 h-6 text-gold-600 group-hover:text-forest-700 transition-colors" strokeWidth={1.4} />
                  <div className="mt-6 text-sm text-forest-700 leading-snug">{item}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
